import { useMemo } from 'react'
import { defaultBullets, featureName } from '../../constants/app'
import {
  getSidebarBullets,
  selectCustomerServicePhone,
} from '../../features/appConfigSlice'
import { selectSelectedClinic } from '../../features/clinicScreen/clinicScreenSlice'
import { useAppSelector } from '../../hooks/useAppSelector'
import SidebarBulletItem from './SidebarBulletItem'
import { useFeatureIsOn } from '@growthbook/growthbook-react'
import { sidebarBulletItem } from './SidebarBulletItem.css'
import SVGIcon from '../SVGIcon/SVGIcon'
import { SVGIconType } from '../../models/enums'

const SidebarBullets = () => {
  const sidebarBullets = useAppSelector(getSidebarBullets)
  const customerServicePhone = useAppSelector(selectCustomerServicePhone)
  const selectedClinic = useAppSelector(selectSelectedClinic)
  const clinicPhoneNumber = selectedClinic && selectedClinic.phoneNumber
  const phoneButtonEnabled = useFeatureIsOn(featureName.phoneCall)
  const clinicPhone = clinicPhoneNumber
    ? clinicPhoneNumber
    : customerServicePhone

  const calculatedBullets = useMemo(() => {
    const resultBullets: string[] = []

    if (!sidebarBullets || (sidebarBullets && sidebarBullets.length === 0)) {
      resultBullets.push(...defaultBullets)
    } else {
      resultBullets.push(...sidebarBullets)
    }

    return resultBullets
  }, [sidebarBullets])

  return (
    <ul data-testid="sidebar-bullets">
      {calculatedBullets.map((bullet, index) => (
        <SidebarBulletItem bullet={bullet} key={index} />
      ))}
      {phoneButtonEnabled && clinicPhone && (
        <li className={sidebarBulletItem} data-testid="bullet-item">
          <SVGIcon width={25} height={20} icon={SVGIconType.CheckMark} />
          <a
            href={`tel:${clinicPhone.replace(/\D/g, '')}`}
            className={sidebarBulletItem}
            target="_top"
          >
            Ring oss på {clinicPhone}
          </a>
        </li>
      )}
    </ul>
  )
}

export default SidebarBullets
